import React from "react";
import { Navigate } from "react-router-dom";
import { getTenantScope } from "@/lib/api";
import Dashboard from "@/pages/Dashboard";

/** When role=client, /dashboard renders the client's own Hub-and-Spoke portal instead of the ISOQuest master dashboard. */
export default function ClientHomeRedirect() {
  const scope = getTenantScope();
  const clientRoles = new Set(["client", "client_admin", "client_employee"]);
  if (clientRoles.has(scope?.role) && scope?.slug) {
    return <Navigate to={`/clients/${scope.slug}`} replace />;
  }
  return <Dashboard />;
}
